import React, { useState } from "react";
import classes from "../Tags/Tags.module.css";
import { styled, alpha } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import SubjectIcon from "@mui/icons-material/Subject";
import axios from "axios";
import { config } from "../../Network_Calls/config";

const Tags = (props) => {
  const [option, setOption] = useState(false);
  const [data, setData] = useState(props.tag);
  const [selectTag, setSelectTag] = useState("All");

  const [list, setList] = useState("");
  const [tagList, setTagList] = useState([]);

  const deleteTag = async (tag) => {
    const response = await axios.delete(
      process.env.REACT_APP_SERVER_URL + "/user/tags?tagname=" + tag,
      {
        ...config,
      }
    );
    const data = await response.data;
    if (data.msg === "Item Deleted Successfully") {
      props.tagDelete(tag);
    }
  };

  ////CLear button functions

  // const clearClickHandler = (event) => {
  //   let clickedItem = event.target.value;
  //   console.log(clickedItem);
  //   // tags=tags.filter(())
  // };

  // MATERIAL UI OPTION BUTTON FUNCTIONS
  const StyledMenu = styled((props) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      {...props}
    />
  ))(({ theme }) => ({
    "& .MuiPaper-root": {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color:
        theme.palette.mode === "light"
          ? "rgb(55, 65, 81)"
          : theme.palette.grey[300],
      boxShadow:
        "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
      "& .MuiMenu-list": {
        padding: "4px 0",
      },
      "& .MuiMenuItem-root": {
        "& .MuiSvgIcon-root": {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        "&:active": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity
          ),
        },
      },
    },
  }));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (value) => () => {
    // console.log(value);
    props.onSelect(value);
    setSelectTag(value);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  ///array of taglist
  // console.log(tagList)
  // console.log(props.clickedtag);

  ///clicked tag element

  // console.log(props.tag,"iiiii")
  return (
    <div className={classes.tags}>
      {props.tag.map((el, index) => (
        <div
          key={index}
          className={
            selectTag===el ? classes.active : classes.tagCard
            // props.clickedtag.includes(el)
            //   ? classes.active
            //   : true
            //   ? classes.tagCard
            //   : null
          }
          onClick={
            handleClick(el)

            // setList(el);
            // if (tagList.includes(el)) {
            //   // setList(el)
            //   setTagList(tagList.filter((item) => item !== el));
            //    props.selectTag(tagList.filter((item) => item !== el));
            // } else {
            //   // console.log("else");
            //   setTagList([...tagList, el]);
            //   props.selectTag([...tagList,el])
            // }
            // setList(el);
            // return setColor(true);
          }
        >
          {el}
          {option && (
            <ClearIcon
              onClick={() => {
                deleteTag(el).catch((err) => console.log(err));
                // let updateTag = tags.filter((item) => el !== item);
                // setTags(updateTag);
              }}
              sx={{ fontSize: "inherit", marginLeft: "10px" }}
            />
          )}
        </div>
      ))}

      {/* <div className={classes.option}>
        <IconButton
          sx={{ fontSize: "inherit" }}
          id="demo-customized-button"
          aria-controls={open ? "demo-customized-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          // variant="contained"
          disableElevation
          onClick={handleClick}
          // endIcon={<KeyboardArrowDownIcon />}
        >
          <i class="fa-solid fa-ellipsis-vertical"></i>
        </IconButton>
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            "aria-labelledby": "demo-customized-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <MenuItem onClick={handleClose} disableRipple>
            <SubjectIcon />
            Show All Tags
          </MenuItem>
          <div
            onClick={() => {
              return setOption(true);
            }}
          >
            {" "}
            <MenuItem onClick={handleClose} disableRipple>
              <EditIcon />
              Edit
            </MenuItem>
          </div>
        </StyledMenu>
      </div> */}
    </div>
  );
};

export default Tags;
